import { render, staticRenderFns } from "./premio.vue?vue&type=template&id=182416f0&"
import script from "./premio.vue?vue&type=script&lang=js&"
export * from "./premio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports